/**
 * @fileoverview GET handler for the "/alloys/partners/google-postmaster/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersGooglePostmasterAppGroupId } from "./constants";
import type { GetAlloysPartnersGooglePostmasterAppGroupIdResult } from "./types";
import { isGetAlloysPartnersGooglePostmasterAppGroupIdResult } from "./validators";

export const getAlloysPartnersGooglePostmasterAppGroupId = reactQueryFetcherAdapter(
  alloysPartnersGooglePostmasterAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<GetAlloysPartnersGooglePostmasterAppGroupIdResult> => {
    return fetch(
      `/alloys/partners/google-postmaster/${appGroupId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysPartnersGooglePostmasterAppGroupIdResult
);
